import { Module } from 'app/library/module/models/module.model';
import { User } from 'app/projects/user/src/lib/models/user';
import { IGradeQuery } from '../../grading-scheme/interfaces/grade.query.interface';
import { IFinalGradeExtendedQuery } from '../interfaces/final-grade-extended.query.interface';

export class FinalGradeExtended {
    static label_singular = 'final-grade';
    static label_plural = 'final-grades';

    static props_to_search = ['comment', 'user', ...User.props_to_search];

    id: string = null;
    comment: string = null;
    moduleId: string = null;
    module?: Module = null;
    participantId: string = null;
    user?: User = null;
    gradeId: string = null;
    grade: IGradeQuery = null;
    status: string = 'published';
    averageScore: number;

    constructor(query?: IFinalGradeExtendedQuery) {
        if (query) {
            if (query.id) {
                this.id = query.id.toString();
            }
            this.comment = query.comment;
            if (query.module && query.module.id) {
                this.moduleId = query.module.id.toString();
            }
            if (query.participant && query.participant.id) {
                this.participantId = query.participant.id.toString();
            }
            if (query.grade && query.grade.id) {
                this.gradeId = query.grade.id.toString();
                this.grade = query.grade;
            }
            this.status = query.status;
            this.averageScore = query.average_score;
        }
    }

    get userFullName(): string {
        return this.user ? this.user.fullName : '';
    }

    get published(): boolean {
        return this.status === 'published';
    }
}
